
import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";
import { GetAvailableCompaniesQuery } from "@/modules/bank/application/GetAvailableCompanies";

export class MountBankAccountList {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number, limit, offset): Promise<any> {
    let args = { 
      company_id: company_id,
    }
    this.frontend.loading_bank_accounts(true)
    let data = await this.dispatcher.dispatch('bank_account.data', args)
    this.frontend.loading_bank_accounts(false)
    if (data.status === '200') {
      this.frontend.bank_accounts = data.data.slice(offset, offset + limit)
      this.frontend.selectedItems = []
      this.frontend.totalItems = data.data.length
      if(this.frontend.totalItems > 0) {
        this.frontend.showSelect = true
        await new GetAvailableCompaniesQuery(this.dispatcher, this.frontend).run(company_id)
      }
      this.frontend.selectAllItems = false;
      this.frontend.bank_accounts.forEach(item => {
        this.frontend.$set(this.frontend.editedBankAccounts, item.id, item.cuenta_bancos || '');
        this.frontend.dirtyStates.set(`${item.id}-save-bank-account`, false);
      });
      this.frontend.bank_accounts.forEach(item => {
        this.frontend.$set(this.frontend.editedPartidasAbiertas, item.id, item.cuenta_partidas_abiertas || '');
      });
    } else {
      this.frontend.bank_accounts = []
      return 'There is no data for this company id'
    }
  }
}